import React from "react";
import { Route, Routes } from "react-router-dom";
import SignIn from "../auth/signIn/SignIn";
import Dashboard from "../dashboard/Dashboard";
import ProjectLayout from "../layout/ProjectLayout";

const Container = () => {
  return (
    <Routes>
      {/* Nested route for ProjectLayout */}
      <Route path="/" element={<ProjectLayout />}>
        <Route index element={<Dashboard  />} />
        <Route path="top" element={<Dashboard  />} />
        <Route path="startup" element={<Dashboard  />} />
        <Route path="free" element={<Dashboard  />} />
        <Route path="prod" element={<Dashboard  />} />
      </Route>

      {/* Routes without ProjectLayout */}
      <Route path="auth/sign-in" element={<SignIn />} />
    </Routes>
  );
};

export default Container;